import React from 'react';
import { C } from '../lib/theme';

const MOCK_CLINICS = [
  { id: '1', name: 'Clínica Godoy Estética', patients: 48, plan: 'Pro', revenue: 349, active: true },
  { id: '2', name: 'Centro Médico Bienestar', patients: 23, plan: 'Básico', revenue: 149, active: true },
  { id: '3', name: 'Clínica Nutrimédica Sur', patients: 61, plan: 'Pro', revenue: 349, active: true },
  { id: '4', name: 'Consulta Dra. Vega', patients: 12, plan: 'Piloto', revenue: 0, active: true },
];

const GLOBAL_STATS = {
  totalPatients: 144,
  activeClinic: 4,
  monthlyRevenue: 847,
  avgEngagement: 74,
  totalMessages: 3820,
  veraCoverage: 89,
};

export default function AdminDashboard({ user, profile, onSignOut }) {
  return (
    <div style={{ maxWidth: 480, margin: '0 auto', fontFamily: 'sans-serif', background: C.cream, minHeight: '100vh', padding: '1rem', paddingBottom: '2rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
        <div>
          <h2 style={{ margin: 0, fontFamily: 'Georgia, serif', color: C.sage }}>🌿 Admin Vera GLP</h2>
          <p style={{ margin: '0.2rem 0 0', fontSize: '0.8rem', color: C.gray }}>Panel de gestión global · Dr. Fernando Godoy</p>
        </div>
        <button onClick={onSignOut} style={{ padding: '0.5rem 0.9rem', borderRadius: 8, border: `1.5px solid ${C.mint}`, background: '#fff', color: C.sage, fontWeight: 600, cursor: 'pointer', fontSize: '0.85rem' }}>
          Salir
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.7rem', marginBottom: '1.5rem' }}>
        {[
          { label: 'Pacientes totales', val: GLOBAL_STATS.totalPatients, icon: '👥' },
          { label: 'Clínicas activas', val: GLOBAL_STATS.activeClinic, icon: '🏥' },
          { label: 'Ingresos MRR', val: `${GLOBAL_STATS.monthlyRevenue}€`, icon: '💶' },
          { label: 'Engagement medio', val: `${GLOBAL_STATS.avgEngagement}%`, icon: '📈' },
          { label: 'Mensajes a Vera', val: GLOBAL_STATS.totalMessages.toLocaleString(), icon: '💬' },
          { label: 'Cobertura Vera', val: `${GLOBAL_STATS.veraCoverage}%`, icon: '🤖' },
        ].map(s => (
          <div key={s.label} style={{ background: '#fff', borderRadius: 14, padding: '1rem', boxShadow: '0 2px 8px rgba(44,106,79,0.07)', textAlign: 'center' }}>
            <div style={{ fontSize: '1.4rem', marginBottom: '0.2rem' }}>{s.icon}</div>
            <div style={{ fontFamily: 'Georgia, serif', fontSize: '1.5rem', fontWeight: 700, color: C.sage }}>{s.val}</div>
            <div style={{ fontSize: '0.73rem', color: C.gray, marginTop: '0.1rem' }}>{s.label}</div>
          </div>
        ))}
      </div>

      <h3 style={{ margin: '0 0 0.8rem', fontFamily: 'Georgia, serif', color: C.carbon }}>Clínicas activas</h3>
      {MOCK_CLINICS.map(clinic => (
        <div key={clinic.id} style={{ background: '#fff', borderRadius: 14, padding: '1rem 1.2rem', boxShadow: '0 2px 8px rgba(44,106,79,0.07)', marginBottom: '0.7rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.4rem' }}>
            <div style={{ fontWeight: 700, color: C.carbon }}>{clinic.name}</div>
            <div style={{
              background: clinic.revenue === 0 ? '#FEF3C7' : C.mintLt,
              color: clinic.revenue === 0 ? '#92400E' : C.sage,
              borderRadius: 20, padding: '0.2rem 0.7rem', fontSize: '0.75rem', fontWeight: 700,
            }}>
              {clinic.plan}
            </div>
          </div>
          <div style={{ display: 'flex', gap: '1.5rem', fontSize: '0.82rem', color: C.gray }}>
            <span>👥 {clinic.patients} pacientes</span>
            <span>💶 {clinic.revenue}€/mes</span>
          </div>
        </div>
      ))}

      <div style={{ background: C.mintLt, borderRadius: 14, padding: '1rem 1.2rem', marginTop: '1.5rem', border: `1px dashed ${C.mint}` }}>
        <h4 style={{ margin: '0 0 0.4rem', color: C.sage }}>Integración Stripe</h4>
        <p style={{ margin: 0, fontSize: '0.85rem', color: C.gray }}>Preparado para conectar pagos automáticos. Próximamente en v2.0.</p>
      </div>

      <div style={{ background: '#fff', borderRadius: 14, padding: '1rem 1.2rem', marginTop: '1rem', boxShadow: '0 2px 8px rgba(44,106,79,0.07)' }}>
        <h4 style={{ margin: '0 0 0.4rem', color: C.carbon }}>Roadmap Vera v2.0</h4>
        <ul style={{ margin: 0, paddingLeft: '1.2rem', fontSize: '0.85rem', color: C.gray, lineHeight: 1.8 }}>
          <li>Vera Bariátrica — pacientes post bypass, manga gástrica y balón</li>
          <li>Integración Stripe para facturación automática</li>
          <li>Artículo científico: Obesity Surgery (en preparación)</li>
          <li>Farmacia QR — distribución masiva GLP-1</li>
        </ul>
      </div>
    </div>
  );
}
